import { Download } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ExportButtonsProps {
  endpoint: string;
  params?: Record<string, string | undefined>;
  /** When true, also offer a PDF download link (format=pdf). */
  pdf?: boolean;
}

export const linkClass = cn(
  'inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md border border-input bg-background',
  'text-xs font-medium text-muted-foreground',
  'hover:bg-accent hover:text-accent-foreground hover:border-accent-foreground/20',
  'transition-colors duration-150 select-none',
);

export function ExportButtons({ endpoint, params, pdf = false }: ExportButtonsProps) {
  function qs(format: string): string {
    const sp = new URLSearchParams();
    Object.entries(params ?? {}).forEach(([k, v]) => {
      if (v !== undefined && v !== '') sp.set(k, v);
    });
    sp.set('format', format);
    return `${endpoint}?${sp.toString()}`;
  }

  return (
    <div className="flex items-center gap-1.5">
      <a href={qs('csv')} download className={linkClass}>
        <Download className="h-3 w-3" />
        CSV
      </a>
      <a href={qs('xlsx')} download className={linkClass}>
        <Download className="h-3 w-3" />
        Excel
      </a>
      {pdf && (
        <a href={qs('pdf')} download className={linkClass}>
          <Download className="h-3 w-3" />
          PDF
        </a>
      )}
    </div>
  );
}
